// Unified card wrapper classes shared by all per-event-type Row components.
//
// Each row renders as a discrete chip (bg + border + rounded + gap below)
// so the feed reads as a stack of distinct posts instead of one blurred
// blob. Matches CLAUDE.md Clean Design tokens: gray-200 borders + light
// /  #0a0a0b dark backgrounds, no neon, hover bumps border subtly.
export const CARD_BASE = "relative bg-white dark:bg-[#18181D] border border-gray-200 dark:border-[#1A1A1A] rounded-[5px] cursor-pointer hover:border-gray-300 dark:hover:border-white/[0.08] transition-colors mb-5 px-3";
